import authAxios from "@/utilities/authAxios.js";
import handleError from "@/utilities/handleError.js";
import { rejectOnAxiosError } from "@/utilities/error-handling/handleAxiosError.js";

export async function createLabel(params) {
  return authAxios.post(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/document/label", { ownerClazz: "orderHeader", format: "application/pdf", docTypeCode: "LBL", ...params })
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

export async function getDocument(id, errorOptions = { showErrors: true }) {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/document" + `/${id}`, { responseType: "blob" })
  .then(response => response.data).catch(error => { if (errorOptions.showErrors) handleError(error); return { httpError: true, httpErrorDetails: error }; });
}

export async function combineDocuments(documentIds) {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/document/combine", { params: { mediaIds: documentIds.join(",") }, responseType: "blob" })
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

export async function deleteDocument(id) {
  return authAxios.delete(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/document", { params: { entityId: id } })
    .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
}

export async function editDocument(params, errorOptions = { showErrors: true }) {
  return authAxios.put(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/document", params)
    .then(response => response.data).catch(error => { if (errorOptions.showErrors) handleError(error); return { httpError: true, httpErrorDetails: error }; });
}

export async function editDocuments(params, errorOptions = { showErrors: true }) {
  return authAxios.put(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/document/batch", params)
    .then(response => response.data).catch(error => { if (errorOptions.showErrors) handleError(error); return { httpError: true, httpErrorDetails: error }; });
}

export async function generateDocument(params, errorOptions = { showErrors: true }) {
  return authAxios.post(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/document/generate", null, { params, headers: { "Content-Type": "application/json" } })
    .then(response => response.data).catch(error => { if (errorOptions.showErrors) handleError(error); return { httpError: true, httpErrorDetails: error }; });
}

export async function uploadDocuments(params, body, errorOptions = { showErrors: true }) {
  return authAxios.post(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/document", body, { params: { ownerClazz: "orderHeader", ...params }, headers: { "Content-Type": "multipart/form-data" } })
    .then(response => response.data).catch(error => { if (errorOptions.showErrors) handleError(error); return { httpError: true, httpErrorDetails: error }; });
}

export async function createDescriptionLabel(data, config = {}) {
  const baseConfig = {
    responseType: "blob",
    validateStatus: (status) => {
      return (status >= 200 && status < 300) || status === 400
    }
  };
  Object.assign(config, baseConfig);
  return authAxios.post(`${import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL}/v2/document/description/label`, data, config)
    .catch(error => { handleError(error); return { httpError: true, httpErrorDetails: error }; });
}

export async function associateDocumentToEntity(data, config, handleErr, errMsg) {
  return authAxios.post(`${import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL}/v2/document/associate`, data, config)
    .then(response => response.data).catch(error => rejectOnAxiosError(error, errMsg || "There was a problem completing the document association.", handleErr));
}

export async function getDocumentPreview(documentId, params, handleError, customFallbackErrorMessage) {
  return authAxios.get(import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL + "/v2/document/preview/" + documentId, { params })
    .then(response => response.data, (err) => rejectOnAxiosError(err, customFallbackErrorMessage || "An error occurred while fetching the document preview.", handleError));
}

export async function replaceDocument(documentId, data, options = { config: null, customErrMsg: '', handleErr: false }) {
  return authAxios.put(`${import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL}/v2/document/${documentId}/replace`, data, { headers: { "Content-Type": "multipart/form-data" }, ...options.config })
    .then(response => response.data, (err) => rejectOnAxiosError(err, options.customErrMsg || "An error occurred while replacing the document.", options.handleErr));
} 

export async function restoreDocumentFromGlacier(documentId, params, options = { config: null, customErrMsg: '', handleErr: false }) {
  return authAxios.put(`${import.meta.env.VITE_WHQ_COREDATA_SERVICE_URL}/v2/document/${documentId}/restore`, null, { params }, options.config)
    .then(response => response.data).catch((err) => rejectOnAxiosError(err, options.customErrMsg || 'There was an error restoring the document.', options.handleErr))
}